<div style="display: flex; flex-direction: column; position: relative">
  <div #highlight class="highlight"></div>
  @for (outlineItem of outlineItems; track outlineItem; let i = $index) {
    <div
      [ngClass]="outlineItemIndex === i ? 'item-selected' : 'item-not-selected'"
      [class]="'item-' + i"
      style="word-wrap: break-word">
      {{outlineItem}}
    </div>
  }
</div>
